export default "__VITE_ASSET__BmRaqJUs__"